import {
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
} from "@coreui/react";
import { useState } from "react";
import { Link } from "react-router-dom";
import { colors } from "../../../config/theme";
import { tdStyle, thStyle } from "../../../helpers/constants";
import { IconAction } from "../../../helpers/general";
import DeleteIcon from "../../icons/DeleteIcon";
import PromptModal from "../../modals/PromptModal";
import { ProfilePictureAvatar } from "../../taxi/Profile_picture_avatar";

interface ReviewTableProps {
  reviews: any[];
  deleteReview: (id: string) => void;
  isDeletingReview: boolean;
}

export default function ReviewTable({
  reviews,
  deleteReview,
  isDeletingReview,
}: ReviewTableProps) {
  const [reviewToDeleteId, setReviewToDeleteId] = useState<string | null>(null);

  const closeModal = () => setReviewToDeleteId(null);

  const confirmDelete = async () => {
    if (!reviewToDeleteId) return;
    await deleteReview(reviewToDeleteId);
    closeModal();
  };

  return (
    <>
      <CTable responsive hover align="middle" className="mb-0">
        <CTableHead>
          <CTableRow>
            <CTableHeaderCell style={thStyle}>
              Référence du trajet
            </CTableHeaderCell>
            <CTableHeaderCell style={thStyle}>Chauffeur</CTableHeaderCell>
            <CTableHeaderCell style={thStyle}>Date</CTableHeaderCell>
            <CTableHeaderCell style={thStyle}>Commentaire</CTableHeaderCell>
            <CTableHeaderCell style={thStyle}>Note</CTableHeaderCell>
            <CTableHeaderCell style={{ ...thStyle, textAlign: "right" }}>
              Actions
            </CTableHeaderCell>
          </CTableRow>
        </CTableHead>
        <CTableBody>
          {reviews.map((review) => (
            <CTableRow key={review.id}>
              <CTableDataCell style={tdStyle}>
                <Link
                  to={`/rides/${review.rideId}/ridedetails`}
                  state={{ review }}
                >
                  {review.reference || "N/A"}
                </Link>
              </CTableDataCell>

              <CTableDataCell style={tdStyle}>
                <div className="d-flex align-items-center gap-2">
                  <ProfilePictureAvatar
                    profilePicture={review.driver?.profilePicture}
                    fullName={review.driver?.fullName}
                    isOnline={review.driver?.driverProfile?.isOnline}
                  />
                  <Link
                    to={`/drivers/${review.driver?.id}`}
                    className="fw-semibold"
                  >
                    {review.driver?.fullName}
                  </Link>
                </div>
              </CTableDataCell>

              <CTableDataCell style={tdStyle}>
                {new Date(review.createdAt).toLocaleDateString()}
              </CTableDataCell>

              <CTableDataCell
                style={{ ...tdStyle, maxWidth: 240, whiteSpace: "normal" }}
              >
                {review?.comment || "Aucun commentaire"}
              </CTableDataCell>

              <CTableDataCell style={tdStyle}>
                {review?.rating ? `${review.rating}/5` : "-"}
              </CTableDataCell>

              <CTableDataCell style={tdStyle}>
                <div className="d-flex align-items-center justify-content-end gap-2">
                  <IconAction
                    title="Supprimer"
                    danger
                    onClick={() => setReviewToDeleteId(review.reviewId)}
                  >
                    <DeleteIcon width="18" height="18" fill={colors.primary} />
                  </IconAction>
                </div>
              </CTableDataCell>
            </CTableRow>
          ))}
        </CTableBody>
      </CTable>

      <PromptModal
        open={reviewToDeleteId !== null}
        onClose={closeModal}
        onAccept={confirmDelete}
        loading={isDeletingReview}
      />
    </>
  );
}
